import React, { useState } from 'react';
import { VertBox } from 'component/basics';
import { BlocklistTextInputWithChips } from 'open-modules/zdf/component/blocklist/blocklistTextInput';
import { component, demoFile } from 'system/demo';

demoFile('open-modules/zdf/component/blocklist-input');

function BlocklistTextInputWithChipsDemo() {
    const [inputText, setInputText] = useState('');
    const [terms, setTerms] = useState<string[]>([]);
    const [errorMessage, setErrorMessage] = useState('');

    return (
        <VertBox gap={8}>
            <BlocklistTextInputWithChips
                inputText={inputText}
                setInputText={setInputText}
                terms={terms}
                setTerms={setTerms}
                testID="input"
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
            />
        </VertBox>
    );
}

component('BlocklistTextInputWithChips', BlocklistTextInputWithChipsDemo);
